const initServicesOffer = () => {
	const section = document.querySelector('.services-offer');

	if (!section) {
		return;
	}

	const navWrap = section.querySelector('.services-offer__nav-wrap');
	const pills = Array.from(section.querySelectorAll('.services-offer__pill'));
	const header = document.querySelector('.site-header');
	const contentSections = pills
		.map((pill) => document.querySelector(pill.getAttribute('href')))
		.filter(Boolean);

	if (!navWrap || !pills.length || !contentSections.length) {
		return;
	}

	let clickedTarget = null;
	let clickedScrollEnd = null;

	const setActivePill = (id = '') => {
		pills.forEach((pill) => {
			const isActive = pill.getAttribute('href') === `#${id}`;
			const becameActive = isActive && !pill.classList.contains('is-active');

			pill.classList.toggle('is-active', isActive);

			if (isActive) {
				pill.setAttribute('aria-current', 'true');
				if (becameActive && window.matchMedia('(max-width: 991.98px)').matches) {
					const rect = pill.getBoundingClientRect();
					const wrapRect = navWrap.getBoundingClientRect();
					const delta = rect.left < wrapRect.left + 16 ? rect.left - wrapRect.left - 16 :
						rect.right > wrapRect.right - 16 ? rect.right - wrapRect.right + 16 : 0;
					if (delta) {
						navWrap.scrollBy({ left: delta, behavior: 'instant' });
					}
				}
			} else {
				pill.removeAttribute('aria-current');
			}
		});
	};

	const getActivationOffset = () => {
		const currentHeaderOffset = header ? header.offsetHeight : 88;
		const navOffset = navWrap.offsetHeight;

		const visibleHeight = window.visualViewport?.height ?? window.innerHeight;
		return currentHeaderOffset + navOffset +
			Math.max(24, (visibleHeight - currentHeaderOffset - navOffset) * 0.28);
	};

	let isTicking = false;

	const updateStickyState = () => {
		const stickyTop = header ? header.offsetHeight : 88;
		const navTop = navWrap.getBoundingClientRect().top;
		const isActivelySticky = Math.abs(navTop - stickyTop) <= 1;

		navWrap.classList.toggle('is-sticky', isActivelySticky);
	};

	const updateActivePill = () => {
		navWrap.classList.toggle('has-overflow', window.matchMedia('(max-width: 991.98px)').matches && navWrap.scrollWidth > navWrap.clientWidth + 1);
		const activationPoint = window.scrollY + getActivationOffset();
		const currentSection = contentSections.reduce((activeSection, contentSection) => {
			if (contentSection.offsetTop <= activationPoint) {
				return contentSection;
			}

			return activeSection;
		}, null);

		updateStickyState();
		if (clickedTarget && clickedScrollEnd !== null && Math.abs(window.scrollY - clickedScrollEnd) > 1) {
			clickedTarget = null;
		}
		if (!clickedTarget) setActivePill(currentSection ? currentSection.id : '');
		isTicking = false;
	};

	const requestActiveUpdate = () => {
		if (isTicking) {
			return;
		}

		isTicking = true;
		window.requestAnimationFrame(updateActivePill);
	};

	pills.forEach((pill) => {
		pill.addEventListener('click', () => {
			const targetId = pill.getAttribute('href').slice(1);

			clickedTarget = document.getElementById(targetId);
			clickedScrollEnd = null;
			setActivePill(targetId);
		});
	});

	// Native scrolling and Lenis both emit scrollend; keep the clicked pill until then.
	window.addEventListener('scrollend', (event) => {
		if (event.target !== document && event.target !== window) return;
		if (document.documentElement.classList.contains('lenis-scrolling') && !event.detail?.lenisScrollEnd) return;
		// A short section can end above the manual activation line. Keep the clicked
		// category at its destination until the user actually continues scrolling.
		if (clickedTarget) clickedScrollEnd = window.scrollY;
	});
	const resumeManualTracking = () => { clickedTarget = null; requestActiveUpdate(); };
	window.addEventListener('wheel', resumeManualTracking, { passive: true });
	window.addEventListener('touchstart', resumeManualTracking, { passive: true });
	window.addEventListener('keydown', (event) => {
		if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) resumeManualTracking();
	});

	// An incoming fragment uses native smooth scrolling on touch devices. Lock its
	// destination before the first observer update, just like a click on a pill.
	const lockHashTarget = () => {
		let id;
		try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
		const target = contentSections.find(contentSection => contentSection.id === id);
		if (!target) return;
		clickedTarget = target;
		clickedScrollEnd = null;
		setActivePill(target.id);
	};
	lockHashTarget();
	window.addEventListener('hashchange', lockHashTarget);
	updateActivePill();
	window.addEventListener('scroll', requestActiveUpdate, { passive: true });
	window.addEventListener('resize', requestActiveUpdate);
	window.visualViewport?.addEventListener('resize', requestActiveUpdate);
};

export default initServicesOffer;
